import { useEffect, useState } from 'react'
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import axios from 'axios';
import { PATIENT } from '../services/routes';
import { Redirect, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import InputMask from 'react-input-mask'
import { Footer } from '../components/Footer';


const NewPatient = () => {

  const { id } = useParams()

  console.log('idPatient ', id)

  const token = localStorage.getItem('token')

  const [name, setName] = useState('')
  const [lastname, setLastname] = useState('')
  const [birthDate, setBirthDate] = useState('')
  const [cpf, setCpf] = useState('')
  const [company, setCompany] = useState('')
  const [occupation, setOccupation] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [street, setStreet] = useState('')
  const [number, setNumber] = useState('')
  const [addressDetails, setAddressDetails] = useState('')
  const [district, setDistrict] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [observation, setObservation] = useState('')
  const [searchCEP, setSearchCEP] = useState([])

  const getPatientId = () => {
    let data
    axios.get(PATIENT.GET.replace(/:id/gi, id),
      {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        console.log('patientId ', res.data)
        data = res.data.patient

        setName(data.name)
        setLastname(data.lastname)
        setBirthDate(formatDate(data.birthDate))
        setCpf(data.cpf)
        setCompany(data.company)
        setOccupation(data.occupation)
        setEmail(data.email)
        setPhone(data.phone)
        setZipCode(data.zipCode)
        setStreet(data.street)
        setNumber(data.number)
        setAddressDetails(data.addressDetails)
        setDistrict(data.district)
        setCity(data.city)
        setState(data.state)
        setObservation(data.observation)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const formatDate = item => {
    let date = new Date(item)
    let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
    let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    let year = date.getFullYear()

    return `${year}-${month}-${day}`
  }

  useEffect(() => {

    getPatientId()

  }, [])


  const handleSubmit = async (e) => {
    e.preventDefault();
    // if(phone.length !== 11) return;
    // if(cpf.length !== 11) return;
    if (id) {
      await axios.put(PATIENT.UPDATE.replace(/:id/gi, id), {
        name,
        lastname,
        birthDate,
        cpf,
        company,
        occupation,
        email,
        phone,
        zipCode,
        street,
        number,
        addressDetails,
        district,
        city,
        state,
        observation
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then((json) => {
        console.log(json)
        toast.success('Paciente editado!')
        return <Redirect to="/patients" />
      }).catch((err) => {
        console.log(err)
        toast.error('Falha ao adicionar o paciente.')
      })
      return;
    }

    await axios.post(PATIENT.CREATE, {
      name,
      lastname,
      birthDate,
      cpf,
      company,
      occupation,
      email,
      phone,
      zipCode,
      street,
      number,
      addressDetails,
      district,
      city,
      state,
      observation
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then((json) => {
      console.log(json)
      toast.success('Paciente adicionado!')
      return <Redirect to='/patients' />
    }).catch((err) => {
      console.log(err)
      toast.error('Falha ao adicionar o paciente.')
    })
  }

  const validaCEP = (e) => {
    let cep = e.target.value.replace(/\D/g, '');
    if (cep && cep.length !== 8) return;

    axios.get(`https://viacep.com.br/ws/${cep}/json/`)
      .then(res => {
        setSearchCEP(res.data)
        if (res.data.erro !== true) {
          toast.success('CEP encontrado, preenchido automaticamente!')
          console.log('Busca CEP ', res)
          setStreet(res.data.logradouro)
          setDistrict(res.data.bairro)
          setCity(res.data.localidade)
          setState(res.data.uf)
        }
        else toast.error('CEP não encontrado.')
      })
  }

  return (
    <>
      <Helmet>
        <title>Novo paciente - Coluço System</title>
      </Helmet>
      <div id="wrapper">

        <Header active="newPatient" />

        <div id="content-wrapper" className="d-flex flex-column">

          <div id="content">

            <Navbar name="Robert" />

            <div className="container-fluid">

              <h1 className="h3 mb-2 text-gray-800">Novo paciente</h1>

              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">Cadastrar um novo paciente</h6>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-row">
                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label">Nome *</label>
                              <input type="text" value={name} onChange={e => setName(e.target.value)} className="form-control" placeholder="Nome" />
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="mb-3">
                              <label className="form-label">Sobrenome *</label>
                              <input type="text" value={lastname} onChange={e => setLastname(e.target.value)} className="form-control" placeholder="Sobrenome" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Data de Nascimento *</label>
                              <input type="date" value={birthDate} onChange={e => setBirthDate(e.target.value)} className="form-control" placeholder="Data de Nascimento" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">CPF *</label>
                              <InputMask mask="999.999.999-99" maskChar={null} type="text" value={cpf} onChange={e => setCpf(e.target.value)} className="form-control" placeholder="CPF" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Empresa</label>
                              <input type="text" value={company} onChange={e => setCompany(e.target.value)} className="form-control" placeholder="Empresa" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Profissão</label>
                              <input type="text" value={occupation} onChange={e => setOccupation(e.target.value)} className="form-control" placeholder="Profissão" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">E-mail *</label>
                              <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="form-control" placeholder="E-mail" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">WhatsApp *</label>
                              <InputMask mask="(99) 99999-9999" maskChar={null} type="text" value={phone} onChange={e => setPhone(e.target.value)} className="form-control" placeholder="WhatsApp" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">CEP *</label>
                              <InputMask mask="99999-999" maskChar={null} onBlur={validaCEP} type="text" value={zipCode} onChange={e => setZipCode(e.target.value)} className={`form-control ${searchCEP.erro && 'is-invalid'}`} placeholder="CEP" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Rua *</label>
                              <input type="text" value={street} onChange={e => setStreet(e.target.value)} className="form-control" placeholder="Rua" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Número *</label>
                              <input type="text" value={number} onChange={e => setNumber(e.target.value)} className="form-control" placeholder="Número" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Complemento</label>
                              <input type="text" value={addressDetails} onChange={e => setAddressDetails(e.target.value)} className="form-control" placeholder="Complemento" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Bairro *</label>
                              <input type="text" value={district} onChange={e => setDistrict(e.target.value)} className="form-control" placeholder="Bairro" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Cidade *</label>
                              <input type="text" value={city} onChange={e => setCity(e.target.value)} className="form-control" placeholder="Cidade" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Estado *</label>
                              <input type="text" value={state} onChange={e => setState(e.target.value)} className="form-control" placeholder="Estado" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Observação</label>
                              <input type="text" value={observation} onChange={e => setObservation(e.target.value)} className="form-control" placeholder="Observação" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <button type="submit" className="btn btn-primary">{id ? 'Editar' : 'Cadastrar'}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>

          <Footer />

        </div>

      </div>
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
    </>
  )
}

export default NewPatient
